const formattingUtils = {
    formatPhoneNumberForCountry(phoneNumber) {
        if (!phoneNumber)
            return null;

        const firstCharacter = phoneNumber.charAt(0);

        if (firstCharacter === "+")
            return phoneNumber;

        const parsed = parseInt(firstCharacter, 10);

        if (isNaN(parsed))
            return false;

        if (parsed !== 0)
            return "+46" + phoneNumber;

        const formated = "+46" + phoneNumber.substr(1);

        return formated;
    },

    currencyFormatter(number) {
        return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(number);
    },

    calculateByteToRightFormat(byte) {
        const mb = byte / 1024 / 1024;

        if (mb > 1024) {
            const gb = mb / 1024;
            return `${Math.round(gb)} GB`
        }

        return `${Math.round(mb)} MB`
    },

    formatComma(decimal) {
        return decimal.replace(",", ".")
    },

    formatGroupName(group) {
        if (group?.id > 0) {
            return `${group.name} / ${group.id}`;
        } 
    },

    formatDuration(duration) {
        if (!duration) return '-';
        const parts = duration.split(':');
        if (parts.length >= 3) {
            const h = parts[0].replace(/^\d+\./, '');
            const m = parts[1];
            const s = Math.floor(parseFloat(parts[2])).toString().padStart(2, '0');
            return `${h}h ${m}m ${s}s`;
        }
        return duration;
    }
};

export default formattingUtils;
